import {
  EmpBusinessUnit,
  EmpPosition,
  EmployeeUnitPosition,
} from '~/data/employee';
import { EmployeesIndexed } from '~/data/employees';
import { OrganizationUnit } from '~/data/orgunits';

export const getOrganizationUnitName = (
  organizationalUnits: OrganizationUnit[],
  unitId?: number,
): string | undefined => {
  if (!unitId || unitId === -1) {
    return undefined;
  }
  const oganizationalUnit = organizationalUnits.find(
    (orgUnit) => orgUnit.fOrgUnitId === unitId,
  );
  return (
    oganizationalUnit &&
    `${oganizationalUnit.fOrgUnitName} (${oganizationalUnit.fOrgUnitNumber})`
  );
};

export const getAllOrganizationUnitNames = (
  units: EmpBusinessUnit[],
  organizationalUnits: OrganizationUnit[],
  empPosition?: EmpPosition,
): string => {
  const empPositionUnitName = getOrganizationUnitName(
    organizationalUnits,
    empPosition?.fInternalPositionUnit,
  );

  if (!units || units.length === 0) {
    return empPositionUnitName ?? '';
  }

  const businessUnitNames: string[] = units
    .map((unit) => getOrganizationUnitName(organizationalUnits, unit.unitId))
    .filter(Boolean) as string[];

  return [empPositionUnitName, ...businessUnitNames].join('; ');
};

export const getAllUnitPositionNames = (
  unitPositions: EmployeeUnitPosition[],
): string => {
  const empUnitPositions = unitPositions.map(
    (unitPosition) =>
      `${unitPosition.fEmpUnitPos} (${unitPosition.fEmpUnitPosPercent})`,
  );

  return empUnitPositions.join('; ');
};

export const hasPendingUnitPositionChanges = (
  unitPositions: EmployeeUnitPosition[],
  pendingUnitPosition: EmployeeUnitPosition[],
) => {
  const unitPositionIds = unitPositions
    .map((unitPosition) => unitPosition.fEmpId)
    .sort();
  const pendingUnitPositionIds = pendingUnitPosition
    .map((pendingUnitPosition) => pendingUnitPosition.fEmpId)
    .sort();
  return (
    unitPositionIds.length === pendingUnitPositionIds.length &&
    unitPositionIds.every(
      (value, index) => value === pendingUnitPositionIds[index],
    )
  );
};

export const getManagerName = (
  allEmployees: EmployeesIndexed,
  managerId?: number,
): string => {
  if (managerId === undefined) {
    return '';
  }
  const manager = allEmployees[managerId];
  if (!manager) {
    return '';
  }
  return `${manager.fEmpLastName}, ${manager.fEmpFirstName}`;
};

export const getFormattedEmploymentValue = (
  input?: string,
  splitChar?: string,
  joinChar?: string,
): string => {
  if (!input) {
    return '';
  }
  return (
    input.charAt(0).toUpperCase() +
    input.slice(1).toLowerCase().split(splitChar!).join(joinChar)
  );
};

export const getEmploymentFormattedDate = (input?: string): string => {
  if (!input) {
    return '';
  }
  return input.split('-').reverse().join('.');
};

export const getUnitNamesEmployeeIsResponsibleFor = (
  unitIds: number[],
  organizationalUnits: OrganizationUnit[],
): string => {
  return unitIds
    .map((unitId) => {
      const organizationalUnit = organizationalUnits.find(
        (orgUnit) => orgUnit.fOrgUnitId === unitId,
      );
      if (!organizationalUnit) {
        return '';
      }
      return `${organizationalUnit.fOrgUnitName} (${organizationalUnit.fOrgUnitNumber})`;
    })
    .join('\n');
};
